<template>
<!-- :style="`width: 100%;height: ${height}px;background: linear-gradient(115deg, #57c9fe, #5777fe);`" -->
	<div >
		<!-- <ddy></ddy> -->
		<qsxueli @swmuban="swmubanFn" v-if="temp.components == 'qsxueli'"></qsxueli>
		<ddy v-if="temp.components == 'dyy'"></ddy>
	</div>
	
</template>

<script>
import qsxueli from './login_com/qsxueli.vue'
import ddy from './login_com/ddy.vue'
export default {
	name: 'login'
	,props:["muban_bol"]
	,components:{
		qsxueli,
		ddy
	}
	,data () {
		return {
      		temp: this.temp.login,
			height:window.document.body.clientHeight
		}
	}
	,mounted:function(){
	}
	,methods:{
		swmubanFn:function(res){
			this.$emit("swmuban",res);		//修改app.vue 的 muban_bol 值
		}
	}
	,watch: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- scoped单页面有效属性 -->

<style>
/* body #app{min-height:100%;} */
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/components/login.vue